var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCancel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23657 4.23657C3.55199 3.92114 4.06339 3.92114 4.37882 4.23657L13.5 13.3577L22.6212 4.23657C22.9366 3.92114 23.448 3.92114 23.7634 4.23657C24.0789 4.55199 24.0789 5.06339 23.7634 5.37882L14.6422 14.5L23.7634 23.6212C24.0789 23.9366 24.0789 24.448 23.7634 24.7634C23.448 25.0789 22.9366 25.0789 22.6212 24.7634L13.5 15.6422L4.37882 24.7634C4.06339 25.0789 3.55199 25.0789 3.23657 24.7634C2.92114 24.448 2.92114 23.9366 3.23657 23.6212L12.3577 14.5L3.23657 5.37882C2.92114 5.06339 2.92114 4.55199 3.23657 4.23657Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.9cd415cf.svg";
export { ForwardRef as ReactComponent };